import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export function useVaultItemDelete() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  interface VaultDeleteResponse {
    message?: string;
  }

  interface VaultDeleteData {
    key: string;
  }

  return useMutation({
    mutationFn: async (objectData: VaultDeleteData): Promise<VaultDeleteResponse> => {
      const deleteData = {
        key: objectData.key,
      };

      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/delete_vault_item`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(deleteData),
        }
      );
      const data = await response.json();

      if (!response.ok || (typeof data.code === 'number' && data.code >= 400)) {
        throw new Error(data.message || 'Failed to delete vault item');
      }

      return {
        message: data.message,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['objectForm']);
      queryClient.invalidateQueries(['userVaultOptions']);
    },
  });
}
